import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import rmsActions from "../../../../actions/rmsActions";
import { getActivities, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";

import ThisTheme from "../../../../themes/PORTTheme";

import BlankCard from "../../../Common/Card/BlankCard";
import ActivitiesCard from "./ActivitiesCard";
import PORTErrorCard from "../PORTErrorCard";


function MyActivitiesCard() {
    const dispatch = useDispatch();
    const appCode = useSelector(getRmsAppCode);
    const activities = useSelector(getActivities);
    const fetching = useSelector((state) => isFetching(state, DataTypes.ACTIVITIES));

    useEffect(() => {
        if (!!appCode) {
            dispatch(rmsActions.getActivities(appCode));
        }
    }, [dispatch, appCode]);

    if (fetching) return <BlankCard />;

    return activities ? (
        <ActivitiesCard data={activities} theme={ThisTheme} />
    ) : (
        <PORTErrorCard
            resource="activity"
            title="Activities"
            error="No data available"
            message="An error occurred while trying to connect the portfolio service."
        />
    );
}

export default MyActivitiesCard;
